export default "__VITE_ASSET__BwrfAa3___"